/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useState } from "react";
import NDADialog from "./NDADialog";
import Login from "./Login";

interface NotAuthenticatedProps {
  setLoggedInUser: any;
  logout: boolean;
  setLogout: any;
}

const NotAuthenticated = (props: NotAuthenticatedProps) => {
  const [isDemo, setIsDemo] = useState<boolean>(!!process.env.REACT_APP_DEMO);

  return (
    <>
      {isDemo && !props.logout ? (
        <NDADialog open={isDemo} setOpen={setIsDemo} />
      ) : (
        <Login
          setLoggedInUser={props.setLoggedInUser}
          setLogout={props.setLogout}
        />
      )}
    </>
  );
};

export default NotAuthenticated;
